<div id="page--edit-questions">
  <div *ngIf="isLoading">
    <loading-spinner></loading-spinner>
  </div>


  <div *ngIf="!isLoading">
    <mat-drawer-container class="sidenav-container" [hasBackdrop]="true">

      <mat-drawer #Drawer class="edit-panel" position="end">
        <!--CREATE QUESTION GROUP-->
        <div *ngIf="currentPanelOptions === 1">
          <app-save-question-group (complete)="closeDrawer()"></app-save-question-group>
        </div>

        <!--EDIT QUESTION GROUP-->
        <div *ngIf="currentPanelOptions === 2">
          <app-save-question-group [questionGroupId]="questionGroupId" (complete)="closeDrawer()"></app-save-question-group>
        </div>

        <!--CREATE QUESTION-->
        <div *ngIf="currentPanelOptions === 3">
          <app-save-question [questionGroupId]="questionGroupId" [questionGroups]="questionGroups" [questionGroupQuestionIndex]="getNewQuestionIndex(questionGroupId)" (complete)="closeDrawer()"></app-save-question>
        </div>
        <!--EDIT QUESTION-->
        <div *ngIf="currentPanelOptions === 4">
          <app-save-question [questionId]="questionId" [questionGroups]="questionGroups" [questionGroupId]="questionGroupId" (complete)="closeDrawer()"></app-save-question>
        </div>
      </mat-drawer>

      <mat-drawer-content>
        <div class="content__holder">
          <h2 class="list-options__heading heading">Admin: Edit Question Groups</h2>

          <div class="button__row floating">
            <div></div>
            <a class="button--box blue add" (click)="createQuestionGroup()">Create question group</a>
          </div>
        </div>

        <div class="row content-scroller">
          <div class="content__holder">

            <div class="col-md-12">
              <ul class="form-edit__group-list sortable">

                <li class="form-edit__group-item" *ngFor="let group of questionGroups">
                  <h5 class="form-edit__group-title">
                    <span class="form-edit__group-title-text">{{group.name}}</span>
                    <div class="form-edit__group-buttons">
                      <i class="material-icons form-edit__expand-group-icon" title="Expand to view questions in this group"
                         (click)="group.questionGroupId != group.questionGroupId ? true : false"
                         [ngClass]="group.questionGroupId ? 'active' : ''">expand_more</i>
                      <i class="material-icons form-edit__edit-icon edit--group active" title="Edit" (click)="editQuestionGroup(group.questionGroupId)">edit</i>
                      <i class="material-icons form-edit__delete-icon" title="Delete" (click)="deleteQuestionGroup(group.questionGroupId)">delete</i>
                    </div>
                  </h5>
                  <ul class="form-edit__question-list sortable" cdkDropList id="q" cdkDropListData="group.questionGroupQuestions" (cdkDropListDropped)="drop($event, group)" [ngClass]="group.questionGroupId ? 'active' : ''">
                    <li class="form-edit__question-item" cdkDropList cdkDragBoundary=".example-boundary" *ngFor="let questionGroupQuestion of group.questionGroupQuestions" cdkDrag>
                      <span style="display:none">{{questionGroupQuestion.index}}</span>
                      <span class="form-edit__question-item-text">{{questionGroupQuestion.question.name}}</span>
                      <div class="form-edit__question-buttons">
                        <!--<i class="material-icons form-edit__move-icon">open_with</i>-->
                        <i class="material-icons form-edit__edit-icon edit--group active" title="Edit" (click)="editQuestion(questionGroupQuestion.questionId, questionGroupQuestion.questionGroupId)">edit</i>
                        <i class="material-icons form-edit__delete-icon" title="Delete" (click)="deleteQuestionFromQuestionGroup(questionGroupQuestion.questionId, questionGroupQuestion.questionGroupId)">delete</i>
                      </div>
                    </li>
                    <!--<li class="form-edit__question-item-add form-edit__edit-icon edit--question unsortable" (click)="addQuestionToQuestionGroup(group.questionGroupId)">
                      <span>Create question</span>
                      <mat-icon class="mat-icon material-icons form-edit__add-icon" role="img" aria-hidden="true">add_circle_outline</mat-icon>
                    </li>-->
                    <li class="button__row">
                      <div></div>
                      <a class="button--box blue add" (click)="addQuestionToQuestionGroup(group.questionGroupId)">Create question</a>
                      <div></div>
                    </li>
                  </ul>
                </li>

                <li class="form-edit__group-item add-group">
                  <a class="form-edit__add-group-icon form-edit__edit-icon edit--group" (click)="createQuestionGroup()">
                    <span>Create question group</span>
                    <mat-icon class="mat-icon material-icons" role="img" aria-hidden="true">add_circle_outline</mat-icon>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </mat-drawer-content>

    </mat-drawer-container>
  </div>
</div>
